var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component"},[_vm._v("\n  エラーが発生しました。"),_c('br'),_vm._v("\n  お手数ですがしばらく経ってから再度ログインしてください。"),_c('br'),_vm._v(" "),_c('hr'),_vm._v("\n  ※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。\n")])}
var staticRenderFns = []

export { render, staticRenderFns }